import React, { useEffect, useRef } from 'react';
import {
  FaTimes,
  FaUserCircle,
  FaTasks,
  FaCalendarAlt,
  FaShieldAlt,
  FaBook,
  FaArrowRight
} from 'react-icons/fa';
import { useTheme } from '../../contexts/ThemeContext';
import styles from './WelcomeModal.module.css';

const STEPS = [
  {
    icon: <FaUserCircle />,
    title: 'Profilinizi Tamamlayın',
    description:
      'İletişim bilgilerinizi ve özgeçmişinizi güncelleyerek profilinizi eksiksiz hale getirin.'
  },
  {
    icon: <FaTasks />,
    title: 'Görevlerinizi Takip Edin',
    description:
      'Size atanan görevleri "Yapılacaklar Listesi" üzerinden görüntüleyin ve durumlarını güncelleyin.'
  },
  {
    icon: <FaCalendarAlt />,
    title: 'Takvim ve Projeler',
    description:
      'Takviminizden planlarınızı, "Projelerim" bölümünden görev aldığınız projeleri takip edin.'
  },
  {
    icon: <FaShieldAlt />,
    title: 'Hesabınızı Güvende Tutun',
    description:
      'Size e-posta ile iletilen geçici şifrenizi ilk fırsatta değiştirmenizi öneririz.'
  }
];

/**
 * Sisteme ilk kez giriş yapan çalışanlara gösterilen karşılama penceresi.
 * Yalnızca bir kez gösterilir; gösterim kararı Dashboard tarafından verilir.
 */
const WelcomeModal = ({ isOpen, userName, onClose, onOpenManual }) => {
  const { isDarkMode } = useTheme();
  const closeButtonRef = useRef(null);

  // Escape ile kapatma ve açılışta odaklanma
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    closeButtonRef.current?.focus();

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className={`${styles.backdrop} ${isDarkMode ? styles.darkMode : ''}`}
      onClick={onClose}
      role="presentation"
    >
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="welcomeModalTitle"
      >
        <button
          type="button"
          ref={closeButtonRef}
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Kapat"
        >
          <FaTimes />
        </button>

        <div className={styles.header}>
          <span className={styles.badge}>Aramıza Hoş Geldiniz</span>
          <h2 id="welcomeModalTitle" className={styles.title}>
            Merhaba{userName ? `, ${userName}` : ''}!
          </h2>
          <p className={styles.subtitle}>
            HabcareCRO Yönetim Portalı’na ilk girişinizi yaptınız. Bu portal üzerinden
            görevlerinizi, projelerinizi, izinlerinizi ve özlük bilgilerinizi tek bir
            yerden yönetebilirsiniz.
          </p>
        </div>

        <div className={styles.steps}>
          {STEPS.map((step) => (
            <div key={step.title} className={styles.stepCard}>
              <div className={styles.stepIcon}>{step.icon}</div>
              <div className={styles.stepContent}>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <p className={styles.footerNote}>
          Herhangi bir sorunuz olursa İnsan Kaynakları ekibimiz size yardımcı olmaktan
          memnuniyet duyar. Başarılar dileriz!
        </p>

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.secondaryButton}
            onClick={onOpenManual}
          >
            <FaBook className={styles.buttonIcon} /> Kullanım Kılavuzu
          </button>
          <button type="button" className={styles.primaryButton} onClick={onClose}>
            Hadi Başlayalım <FaArrowRight className={styles.buttonIcon} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
